// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--zLeA4","children":"layout-module--children--1NiFV"};